import { render, staticRenderFns } from "./ProjectValuationBuyersDataTable.vue?vue&type=template&id=5d5c8fbc&scoped=true&"
import script from "./ProjectValuationBuyersDataTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationBuyersDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationBuyersDataTable.vue?vue&type=style&index=0&id=5d5c8fbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c8fbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCheckbox,VChip})
